var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3591_4265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6921 10.0005C5.69112 9.45294 5.79807 8.91057 6.00683 8.40439C6.2156 7.89821 6.52208 7.43814 6.90876 7.05048L13.7171 0.242147C13.874 0.0852269 14.0868 -0.00292967 14.3088 -0.00292968C14.5307 -0.00292968 14.7435 0.0852269 14.9004 0.242147C15.0574 0.399066 15.1455 0.611895 15.1455 0.833813C15.1455 1.05573 15.0574 1.26856 14.9004 1.42548L8.0921 8.23381C7.62393 8.70256 7.36096 9.33798 7.36096 10.0005C7.36096 10.663 7.62393 11.2984 8.0921 11.7671L14.9004 18.5755C15.0574 18.7324 15.1455 18.9452 15.1455 19.1671C15.1455 19.3891 15.0574 19.6019 14.9004 19.7588C14.7435 19.9157 14.5307 20.0039 14.3088 20.0039C14.0868 20.0039 13.874 19.9157 13.7171 19.7588L6.90876 12.9505C6.52208 12.5628 6.2156 12.1027 6.00683 11.5966C5.79807 11.0904 5.69112 10.548 5.6921 10.0005Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3591_4265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.d6a72e1a58c7f79b226f8a51fa3502e1.svg";
export { ForwardRef as ReactComponent };